// extracted by mini-css-extract-plugin
export var cta = "BulletinBoardCard-module--cta--1f462";
export var ctaWrapper = "BulletinBoardCard-module--ctaWrapper--773d1";
export var wrapper = "BulletinBoardCard-module--wrapper--0d8d6";